import { ILocation } from './types';
import { DEFAULT_PRICE } from 'constants/prices';

export const defaultLocation: ILocation = {
  isReal: false,
  currencyCode: DEFAULT_PRICE.currencyCode,
};
